export const DepartmentDetailsTabsEnum = {
  OVERVIEW: 0,
  USERS: 1,
  KNOWLEDGE_BASES: 2,
  ACTIVITY_LOG: 3,
};

export default DepartmentDetailsTabsEnum;

